module.exports = __webpack_public_path__ + "6b2c6caa03914f73e3a72c61948d66fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/cyklistak-1.jpg
// module id = 1144
// module chunks = 0